import React from 'react';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function AudienceSection() {
  return <section className="bg-[#faf5eb] text-slate-900 py-24 px-4 sm:px-6 lg:px-8" data-id="element-1">
      <div className="max-w-6xl mx-auto" data-id="element-2">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-3">
          {/* Who it is for */}
          <div className="bg-white rounded-3xl p-8 md:p-10 shadow-lg border border-slate-100" data-id="element-4">
            <h3 className="text-2xl font-bold mb-8 text-slate-900 flex items-center" data-id="element-5">
              <span className="bg-green-100 text-green-700 p-2 rounded-lg mr-4" data-id="element-6">
                <CheckCircleIcon className="w-6 h-6" data-id="element-7" />
              </span>
              Para quién es esto
            </h3>

            <ul className="space-y-6" data-id="element-8">
              <li className="flex items-start" data-id="element-9">
                <CheckCircleIcon className="w-6 h-6 text-green-500 mr-4 flex-shrink-0 mt-0.5" data-id="element-10" />
                <span className="text-slate-700 text-lg" data-id="element-11">
                  Personas que trabajan pero sienten que el dinero se les escapa
                  de las manos.
                </span>
              </li>
              <li className="flex items-start" data-id="element-12">
                <CheckCircleIcon className="w-6 h-6 text-green-500 mr-4 flex-shrink-0 mt-0.5" data-id="element-13" />
                <span className="text-slate-700 text-lg" data-id="element-14">
                  Quienes sufren de ansiedad financiera cada fin de mes.
                </span>
              </li>
              <li className="flex items-start" data-id="element-15">
                <CheckCircleIcon className="w-6 h-6 text-green-500 mr-4 flex-shrink-0 mt-0.5" data-id="element-16" />
                <span className="text-slate-700 text-lg" data-id="element-17">
                  Empleados y freelancers que quieren empezar a ahorrar pero no
                  saben por dónde empezar.
                </span>
              </li>
              <li className="flex items-start" data-id="element-18">
                <CheckCircleIcon className="w-6 h-6 text-green-500 mr-4 flex-shrink-0 mt-0.5" data-id="element-19" />
                <span className="text-slate-700 text-lg" data-id="element-20">
                  Quienes tienen una "fuga" constante de dinero en gastos que no
                  recuerdan.
                </span>
              </li>
            </ul>
          </div>

          {/* Who it is NOT for */}
          <div className="bg-slate-50 rounded-3xl p-8 md:p-10 shadow-sm border border-slate-200" data-id="element-21">
            <h3 className="text-2xl font-bold mb-8 text-slate-900 flex items-center" data-id="element-22">
              <span className="bg-red-100 text-red-700 p-2 rounded-lg mr-4" data-id="element-23">
                <XCircleIcon className="w-6 h-6" data-id="element-24" />
              </span>
              Para quién NO es
            </h3>

            <ul className="space-y-6" data-id="element-25">
              <li className="flex items-start" data-id="element-26">
                <XCircleIcon className="w-6 h-6 text-red-400 mr-4 flex-shrink-0 mt-0.5" data-id="element-27" />
                <span className="text-slate-600 text-lg" data-id="element-28">
                  Personas que buscan fórmulas mágicas para hacerse millonarios
                  de la noche a la mañana.
                </span>
              </li>
              <li className="flex items-start" data-id="element-29">
                <XCircleIcon className="w-6 h-6 text-red-400 mr-4 flex-shrink-0 mt-0.5" data-id="element-30" />
                <span className="text-slate-600 text-lg" data-id="element-31">
                  Quienes no están dispuestos a dedicar 20 minutos al mes a
                  organizar su dinero.
                </span>
              </li>
              <li className="flex items-start" data-id="element-32">
                <XCircleIcon className="w-6 h-6 text-red-400 mr-4 flex-shrink-0 mt-0.5" data-id="element-33" />
                <span className="text-slate-600 text-lg" data-id="element-34">
                  Personas con deudas de usura extremas que requieren asesoría
                  legal o judicial.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}